<template>
  <el-row :gutter="20">
      <el-col :span="12" :offset="6">
      <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="name"
            label="用户名">
          </el-table-column>
          <el-table-column
            prop="password"
            label="密码">
          </el-table-column>
        </el-table>
        <div class="grid-content bg-purple">
          <div class="hello">
              <h1>{{ msg }}</h1>

              <form>
                <el-input v-model="name" name="name" placeholder="请输入用户名"></el-input>
                <el-input v-model="password" type="password" name="password" placeholder="请输入密码"></el-input>
                <el-button type="primary" @click="userAdd">添加</el-button>
              </form>
            </div>
        </div>
      </el-col>
  </el-row>

</template>
<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: '添加用户',
      name: '',
      password: '',
      tableData:[]
    }
  },
  mounted: function(){
      this.$nextTick(function () {
          this.$http.get('/api/user/list').then(
                response => {
                  this.tableData = response.data;
                },
                response => {
                  console.log('failed');
                }
              )
        })

  },
  methods: {
    userAdd() {
      var name = this.name;
      var password = this.password;
      this.$http.post('/api/user/addUser', {
        name: name,
        password: password
      }).then((response) => {
        console.log(response);
        if(response.ok){
            this.name = '';
            this.password = '';
            this.tableData.push({name:name,password:password});
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Adduser.vue